// Feature flag to control multi-image AI editing functionality
export const ENABLE_MULTI_IMAGE_AI_EDITING = true // Set to true to enable multi-image features

// Maximum number of images supported for multi-image AI editing
export const MAX_MULTI_IMAGE_COUNT = 3

// Feature flag to control whether Edit With AI works when no object is selected (scene-wide editing)
export const ENABLE_AI_EDIT_ON_DESELECT = false // Set to false to disable AI editing on canvas deselect

// Feature flag to control face detection before AI editing suggestions
export const ENABLE_AI_EDIT_FACE_DETECTION = false // Set to true to enable face detection checks

// Feature flag to use Gemini describeImage for edit suggestions instead of imageEditSuggestions
export const ENABLE_GEMINI_DESCRIBE_IMAGE_SUGGESTIONS = true
